// extracted by mini-css-extract-plugin
module.exports = {"priceTable":"PriceTableForm_priceTable__jXq3n","packerName":"PriceTableForm_packerName__1snUv","isDifferentDate":"PriceTableForm_isDifferentDate__uBVO9"};